var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 16,
    viewBox: "0 0 27 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4713 3.52851C10.7317 3.78886 10.7317 4.21097 10.4713 4.47132L6.94273 7.99992L10.4713 11.5285C10.7317 11.7889 10.7317 12.211 10.4713 12.4713C10.211 12.7317 9.78886 12.7317 9.52851 12.4713L5.52851 8.47132C5.26816 8.21097 5.26816 7.78886 5.52851 7.52851L9.52851 3.52851C9.78886 3.26816 10.211 3.26816 10.4713 3.52851Z",
    fill: "#1B1B1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4713 3.52851C21.7317 3.78886 21.7317 4.21097 21.4713 4.47132L17.9427 7.99992L21.4713 11.5285C21.7317 11.7889 21.7317 12.211 21.4713 12.4713C21.211 12.7317 20.7889 12.7317 20.5285 12.4713L16.5285 8.47132C16.2682 8.21097 16.2682 7.78886 16.5285 7.52851L20.5285 3.52851C20.7889 3.26816 21.211 3.26816 21.4713 3.52851Z",
    fill: "#1B1B1B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.09dbc449a632cbce78e4afced40a612e.svg";
export { ForwardRef as ReactComponent };